import React, { Component } from 'react';

export default class Front extends Component {
  render() {
    return <div className="front tile">{this.props.children}</div>;
  }
}
